import styled from 'styled-components'

export const MainWrapper = styled.section`
    
`